import { render, staticRenderFns } from "./productCodeRule.vue?vue&type=template&id=d1b5bf1c&"
import script from "./productCodeRule.vue?vue&type=script&lang=js&"
export * from "./productCodeRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports